export class DataCookiePedido {
    public intPedidoId?:any;
    public strClavePedido?:any;
}
